var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { runInAction } from "mobx";
import { Column } from "react-vcomponents";
import { BaseComponentPlus, GetInnerComp } from "react-vextensions";
import { store } from "Store";
import { Observer, UseSize, PageContainer } from "vwebapp-framework";
import { DisplayPanel } from "./MapUI/Panels/DisplayPanel";
import { HistoryPanel } from "./MapUI/Panels/HistoryPanel";
import { ObjectPanel } from "./MapUI/Panels/ObjectPanel";
import { ObjectsPanel } from "./MapUI/Panels/ObjectsPanel";
import { ObjectTypesPanel } from "./MapUI/Panels/ObjectTypesPanel";
import { ToolboxPanel } from "./MapUI/Panels/ToolboxPanel";
import { ToolPanel } from "./MapUI/Panels/ToolPanel";
import { MapScene } from "./MapUI/MapScene";
//import React3 from "react-three-renderer";
// temp, till react-three-renderer-fiber is ready
const React3 = (...props) => React.createElement("div", null);
let MapUI = class MapUI extends BaseComponentPlus({}, {}, { viewWidth: 300, viewHeight: 300 }) {
    render() {
        const { book } = this.props;
        const zoomLevel = store.main.write.map.zoomLevel;
        if (book == null)
            return React.createElement("div", null, "Please select a book.");
        const [sceneContainerRef, { width: viewWidth, height: viewHeight }] = UseSize();
        this.Stash({ viewWidth, viewHeight });
        return (React.createElement(PageContainer, { preset: "full", innerStyle: { flexDirection: "row" } },
            React.createElement(Column, { style: { width: 250, height: "100%", background: "rgba(0,0,0,.7)" } },
                React.createElement(ToolboxPanel, null),
                React.createElement(ToolPanel, { mapUI: this }),
                React.createElement(ObjectTypesPanel, null),
                React.createElement(DisplayPanel, { viewWidth: viewWidth, viewHeight: viewWidth, zoomIn: this.ZoomIn.bind(this) })),
            React.createElement(Column, { ref: sceneContainerRef, style: { /*flex: 1,*/ position: "relative", width: "calc(100% - 500px)", height: "100%" } }, viewWidth && viewHeight &&
                React.createElement(MapScene, { ref: c => this.mapScene = GetInnerComp(c), book: book, width: viewWidth, height: viewHeight, zoomIn: this.ZoomIn.bind(this) })),
            React.createElement(Column, { style: { width: 250, height: "100%", background: "rgba(0,0,0,.7)" } },
                React.createElement(ObjectsPanel, { book: book }),
                React.createElement(ObjectPanel, { mapUI: this }),
                React.createElement(HistoryPanel, null))));
    }
    ZoomIn(zoomMultiplier, zoomAnchorPoint_relative) {
        runInAction("MapUI.ZoomIn", () => {
            store.main.write.map.zoomLevel *= zoomMultiplier;
            const zoomLevel = store.main.write.map.zoomLevel;
            const zoomAnchorPoint_relative_fromCenter = zoomAnchorPoint_relative.Minus(.5, .5);
            if (zoomAnchorPoint_relative_fromCenter.x != 0 || zoomAnchorPoint_relative_fromCenter.y != 0) {
                //let {viewWidth, viewHeight} = this.stash;
                const newZoomLevel = zoomLevel * zoomMultiplier;
                const oldMapAreaVisible_meters = this.mapScene.ViewSize_Meters();
                const newMapAreaVisible_meters = this.mapScene.ViewSize_Meters().DividedBy(newZoomLevel / zoomLevel);
                const scrollChange = oldMapAreaVisible_meters.Minus(newMapAreaVisible_meters).Times(zoomAnchorPoint_relative_fromCenter.NewY(y => -y));
                store.main.write.map.viewCenter = store.main.write.map.viewCenter.Plus(scrollChange);
            }
        });
    }
};
MapUI = __decorate([
    Observer
], MapUI);
export { MapUI };
